/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_How_To_PlayInputs */

const bn_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কিভাবে খেলতে হয়`)
};

const de_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie man spielt`)
};

const el_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πώς να παίξετε`)
};

const en_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to play`)
};

const es_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`como jugar`)
};

const fr_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment jouer`)
};

const hi_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैसे खेलने के लिए`)
};

const hu_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hogyan kell játszani`)
};

const id_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara bermain`)
};

const it_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come giocare`)
};

const ja_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`遊び方`)
};

const ko_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플레이 방법`)
};

const nl_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe te spelen`)
};

const pl_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak grać`)
};

const pt_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como jogar`)
};

const ru_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как играть`)
};

const sv_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hur man spelar`)
};

const tr_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nasıl oynanır`)
};

const uk_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Як грати`)
};

const vi_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cách chơi`)
};

const zh_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`怎么玩`)
};

const zh_hant_action_how_to_play = /** @type {(inputs: Action_How_To_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`怎麼玩`)
};

/**
* | output |
* | --- |
* | "How to play" |
*
* @param {Action_How_To_PlayInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_how_to_play = /** @type {((inputs?: Action_How_To_PlayInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_How_To_PlayInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_how_to_play(inputs)
	if (locale === "de") return de_action_how_to_play(inputs)
	if (locale === "el") return el_action_how_to_play(inputs)
	if (locale === "en") return en_action_how_to_play(inputs)
	if (locale === "es") return es_action_how_to_play(inputs)
	if (locale === "fr") return fr_action_how_to_play(inputs)
	if (locale === "hi") return hi_action_how_to_play(inputs)
	if (locale === "hu") return hu_action_how_to_play(inputs)
	if (locale === "id") return id_action_how_to_play(inputs)
	if (locale === "it") return it_action_how_to_play(inputs)
	if (locale === "ja") return ja_action_how_to_play(inputs)
	if (locale === "ko") return ko_action_how_to_play(inputs)
	if (locale === "nl") return nl_action_how_to_play(inputs)
	if (locale === "pl") return pl_action_how_to_play(inputs)
	if (locale === "pt") return pt_action_how_to_play(inputs)
	if (locale === "ru") return ru_action_how_to_play(inputs)
	if (locale === "sv") return sv_action_how_to_play(inputs)
	if (locale === "tr") return tr_action_how_to_play(inputs)
	if (locale === "uk") return uk_action_how_to_play(inputs)
	if (locale === "vi") return vi_action_how_to_play(inputs)
	if (locale === "zh") return zh_action_how_to_play(inputs)
	return zh_hant_action_how_to_play(inputs)
});